export enum HubSpotMeetingLinkTypeKey {
  KICK_OFF = 'kick_off',
  INTAKE = 'intake',
  PATH_TO_PROBATE = 'path_to_probate',
  PROBATE = 'probate',
  GUIDANCE = 'guidance',
  WILL_REVIEW = 'will_review'
}
